/**
 * 默认的apiList（默认申请常用的api）
 */
export var DefaultApiList = [
    /**
     * 关闭当前网页窗口接口
     */
    'closeWindow',
    /**
     * 批量显示功能按钮接口
     */
    'showMenuItems',
    /**
     * 批量隐藏功能按钮接口
     */
    'hideMenuItems',
    /**
     * 隐藏所有非基础按钮接口
     */
    'hideAllNonBaseMenuItem',
    /**
     * 显示所有功能按钮接口
     */
    'showAllNonBaseMenuItem',
    /**
     * 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
     */
    'updateTimelineShareData',
    /**
     * 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
     */
    'updateAppMessageShareData',
];
